<template>

<section class="section">
<div class="container">

<h5 class="title is-5">
    ОБЩИ УСЛОВИЯ ЗА ПРЕДОСТАВЯНЕ НА КРЕДИТИ ЗА НЕДВИЖИИ ИМОТИ НА ПОТРЕБИТЕЛИ
</h5>

<div id="general-terms" class="pre">
  {{ generalTermsText }}
</div>

</div>
</section>
</template>

<script>
export default {
  name: 'GeneralTerms',
  data () {
    return {
      generalTermsText: 'Зарежда се ...'
    }
  },
  created () {
    const axios = this.$axios.create({
      params: { api_key: this.$_config.API_KEY },
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      },
      withCredentials: true
    })

    axios
      .get('https://www.creditgroup.cc/agent-app/api/ipo/policies/general-terms-text')
      .then(response => {
        this.generalTermsText = response.data
      })
      .catch(error => {
        console.error(error)
      })
  },
  mounted () {
    this.$nextTick(() => {
      this.$scrollTo('body', 500, {offset: -0})
    })
  }
}
</script>

<style lang="stylus" scoped>
.pre
  white-space pre-wrap       /* css-3 */
  white-space -moz-pre-wrap  /* Mozilla, since 1999 */
  white-space -pre-wrap      /* Opera 4-6 */
  white-space -o-pre-wrap    /* Opera 7 */
  word-wrap break-word       /* Internet Explorer 5.5+ */
  text-align justify
  // width 94vw
  // margin auto

@media(min-width 768px)
  .pre
    width 70vw
    margin auto
</style>



// WEBPACK FOOTER //
// src/components/policies/GeneralTerms.vue